import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DashpivotEvent, EventNotifierService, EventTypes } from '@site-mate/dashpivot-shared-library';

import { SegmentService } from 'app/segment/segment.service';
import { TeamService } from 'app/shared/service/team.service';

import { ConfirmService } from '../shared/service/confirm.service';
import { ErrorHandler } from '../shared/service/error-handler.service';
import { MetaDataService } from '../shared/service/meta-data.service';
import { ToastrService } from '../shared/service/toastr.service';

@Component({
  selector: 'cc-alignment',
  templateUrl: 'alignment.component.html',
  styleUrls: ['home-settings.component.scss'],
})
export class AlignmentComponent implements OnInit, OnDestroy {
  uploading;
  kml;
  unSubscribe = new Subject<void>();
  projectId;

  constructor(
    private readonly errorHandler: ErrorHandler,
    private readonly metaDataService: MetaDataService,
    private readonly confirmService: ConfirmService,
    private readonly toastr: ToastrService,
    private readonly teamService: TeamService,
    private readonly segmentService: SegmentService,
  ) {}

  ngOnInit(): void {
    this.teamService.currentTeam.pipe(takeUntil(this.unSubscribe)).subscribe((project) => {
      if (project.id && project.isProject) {
        this.projectId = project.id;
        this.loadKML();
      }
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  loadKML() {
    this.metaDataService.getKML(this.projectId).subscribe(
      (res) => {
        if (res.kmlFile !== '') {
          this.kml = res;
          const urlParts = res.kmlFile.split('/');
          this.kml.name = urlParts[urlParts.length - 1];
        }
      },
      (error) => this.errorHandler.handle(error),
    );
  }

  upload(e) {
    const fileList = e.target.files;
    if (fileList.length > 0) {
      const file = fileList[0];
      const formData = new FormData();
      formData.append('file', file);
      this.uploading = true;
      this.metaDataService.uploadKML(this.projectId, formData).subscribe(
        () => {
          void EventNotifierService.notify(
            new DashpivotEvent(EventTypes.ProjectKmlUploaded),
            this.segmentService,
          );
          this.toastr.successByKey('kmlAdded');
          this.uploading = false;
          e.target.value = null;
          this.loadKML();
        },
        (error) => {
          this.uploading = false;
          e.target.value = null;
          this.errorHandler.handle(error);
        },
      );
    }
  }

  removeKML() {
    this.confirmService
      .confirmDelete('deleteKml')
      .then(() => {
        return this.metaDataService.removeKML(this.projectId).subscribe(() => {
          void EventNotifierService.notify(
            new DashpivotEvent(EventTypes.ProjectKmlDeleted),
            this.segmentService,
          );
          this.toastr.successByKey('kmlRemoved');
          this.kml = undefined;
        }, this.errorHandler.handle.bind(this.errorHandler));
      })
      .catch(() => {});
  }
}
